import { createReducer } from "../utils";
import { SET_CAM_GROUP_POSITION, SET_CHANNEL_POSITION, SET_INITIAL_ACTIVE_CHANNEL } from "../constants";

const initialState = {
  camgroupId: null,
  channelId: null,
  activeChannelId: null,
  type: null,
};

export default createReducer(initialState, {
  [SET_CAM_GROUP_POSITION]: (state, payload) => {
    return Object.assign({}, state, {
      camgroupId: payload.data
    });
  },
  [SET_CHANNEL_POSITION]: (state, payload) => {
    return Object.assign({}, state, {
      channelId: payload.data
    });
  },
  [SET_INITIAL_ACTIVE_CHANNEL]: (state, payload) => {
    return Object.assign({}, state, {
      activeChannelId: payload.data,
    });
  }
});
